var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClickerSvgrepoCom(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.296,
    height: 24.001,
    viewBox: "0 0 21.296 24.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "clicker-svgrepo-com",
    transform: "translate(-28.849)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_4225",
    "data-name": "\\uD328\\uC2A4 4225",
    d: "M34.855,0a6.006,6.006,0,0,0-1.093,11.911l0-1.113,0-1.128a3.82,3.82,0,1,1,4.76-2.594l.947.613.936.606A6.008,6.008,0,0,0,34.855,0Z",
    transform: "translate(0)",
    fill: "#f3d096"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_4226",
    "data-name": "\\uD328\\uC2A4 4226",
    d: "M149.189,114.2,135,105.015a1.092,1.092,0,0,0-1.114-.043h0a1.092,1.092,0,0,0-.571.958l-.027,16.9a1.092,1.092,0,0,0,1.944.685l5.2-6.486h0l8.272-.828a1.092,1.092,0,0,0,.485-2Z",
    transform: "translate(-99.542 -99.925)",
    fill: "#5289c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_4227",
    "data-name": "\\uD328\\uC2A4 4227",
    d: "M133.316,108.621l-.027,16.9a1.092,1.092,0,0,0,1.944.685l5.2-6.486-6.547-12.06A1.091,1.091,0,0,0,133.316,108.621Z",
    transform: "translate(-99.544 -102.616)",
    fill: "#5289c9"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClickerSvgrepoCom);
export default __webpack_public_path__ + "static/media/clicker-svgrepo-com.9bea44958f4a8342472a5f6fef9cf51b.svg";
export { ForwardRef as ReactComponent };